<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="border-radius: 16px; width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >ORDER DINE IN</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <div v-for="subItem in items" :key="subItem.check">
          <v-list-tile :to="subItem.url">
            <v-list-tile-action>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                v-if="subItem.check == 'new_order'"
                fab
                color="primary"
                style="height: 28px; width: 28px"
                class="black--text"
                >{{ orderCountNew }}</v-btn
              >
              <v-btn
                v-else-if="subItem.check == 'on_process'"
                fab
                color="primary"
                style="height: 28px; width: 28px"
                class="black--text"
                >{{ orderCountOnProcess }}</v-btn
              >
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="subItem.no_filter_date == true" inset />
        </div>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      title: "",
      items: [
        {
          icon: "mdi-alert-decagram",
          title: "New Order",
          check: "new_order",
          order_status: 1,
          url: "/weserve_admin_login/-/order-dine-in/new-order",
          no_filter_date: false,
        },
        {
          icon: "access_alarm",
          title: "On process",
          check: "on_process",
          order_status: 2,
          url: "/weserve_admin_login/-/order-dine-in/on-process",
          no_filter_date: true,
        },
        {
          icon: "check_circle",
          title: "Complete",
          check: "complete",
          order_status: 3,
          url: "/weserve_admin_login/-/order-dine-in/complete",
        },
        {
          icon: "cancel",
          title: "Cancel",
          check: "cancel",
          order_status: 4,
          url: "/weserve_admin_login/-/order-dine-in/cancel",
        },
      ],
      intervalCountOrder: null,
    };
  },
  computed: {
    ...mapState({
      orderListOnProcess: (state) => state.fetchDineIn.orderListOnProcess,
      orderListNewOrder: (state) => state.fetchDineIn.orderListNewOrder,
    }),
    // derived counts to avoid computing lengths repeatedly in template
    orderCountNew() {
      return Array.isArray(this.orderListNewOrder)
        ? this.orderListNewOrder.length
        : 0;
    },
    orderCountOnProcess() {
      return Array.isArray(this.orderListOnProcess)
        ? this.orderListOnProcess.length
        : 0;
    },
  },
  watch: {
    orderListNewOrder() {
      this.setOrderTitle();
    },
  },
  methods: {
    ...mapActions({
      fetchOrderList: "fetchDineIn/fetchOrderList",
    }),
    setOrderTitle() {
      document.title =
        this.orderCountNew > 0
          ? `(${this.orderCountNew}) ${this.title}`
          : this.title;
    },
    async fetchOrderDineIn() {
      try {
        return await this.fetchOrderList({ order_status: [1, 2] });
      } catch (err) {
        // fail silently but keep console for debugging
        // eslint-disable-next-line no-console
        console.error("fetchOrderDineIn error:", err);
        return null;
      }
    },
    async getData() {
      await this.fetchOrderDineIn();
      // use arrow function to keep lexical this
      this.intervalCountOrder = setInterval(async () => {
        await this.fetchOrderDineIn();
      }, 60000);
    },
  },
  beforeDestroy() {
    document.title = this.title;
    if (this.intervalCountOrder) {
      clearInterval(this.intervalCountOrder);
      this.intervalCountOrder = null;
    }
  },
  created() {
    this.title = document.title;
  },
  mounted() {
    this.getData();
  },
};
</script>
